import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=11188e06&scoped=true"
import script from "./ProductGroup.vue?vue&type=script&lang=js"
export * from "./ProductGroup.vue?vue&type=script&lang=js"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=11188e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11188e06",
  null
  
)

export default component.exports